import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import "./assets/menus.scss";

const SideMenu = ({
    side,
    title,
    iconClass,
    headerIcon,
    expanded,
    setExpanded,
    className = '',
    animate = false,
    children,
}) => {
    const [active, setActive] = useState(animate ? false : expanded);

    useEffect(() => {
        if (!animate) {
            setActive(expanded);
            return undefined;
        }

        if (!expanded) {
            setActive(false);
            return undefined;
        }

        const show = () => setActive(true);
        const frame = typeof window !== 'undefined' && window.requestAnimationFrame
            ? window.requestAnimationFrame(show)
            : setTimeout(show, 0);
        return () => {
            if (typeof frame === 'number' && typeof window !== 'undefined' && window.cancelAnimationFrame) {
                window.cancelAnimationFrame(frame);
            } else {
                clearTimeout(frame);
            }
        };
    }, [animate, expanded]);

    const open = animate ? active : expanded;

    const menu = (
        <div
            className={[
                'row side-menu-container w-100',
                className,
                animate ? 'side-menu-animated' : '',
                open ? 'is-open' : 'is-closing',
            ].filter(Boolean).join(' ')}
        >
            <div
                className={`col-12 col-md-4 col-lg-3 col-xl-2 d-flex flex-column ${side}-menu ${open ? 'show' : ''}`}
                aria-hidden={animate && !expanded}
            >
                <div className="sticky-menu-header side-menu-header">
                    <div className="side-menu-header-title">
                        {headerIcon && <span className="me-2 my-auto">{headerIcon}</span>}
                        {!headerIcon && iconClass && (<i className={`bi ${iconClass} me-2 my-auto`}></i>)}
                        <h5 className="my-auto">
                            {title}
                        </h5>
                    </div>
                    <div className="side-menu-header-actions">
                        <button
                            className="btn btn-sm btn-outline-dark side-menu-close"
                            type="button"
                            onClick={() => setExpanded(false)}
                            title={`Close ${title}`}
                            aria-label={`Close ${title}`}
                        >
                            <i className={`bi bi-arrow-${side}`}></i>
                        </button>
                    </div>
                </div>
                <div className="side-menu-content flex-grow-1 py-2">
                    {children}
                </div>

            </div>
        </div>
    );

    return typeof document === 'undefined'
        ? menu
        : createPortal(menu, document.body);
};

SideMenu.propTypes = {
    side: PropTypes.oneOf(['left', 'right']).isRequired,
    title: PropTypes.string.isRequired,
    iconClass: PropTypes.string,
    headerIcon: PropTypes.node,
    expanded: PropTypes.bool.isRequired,
    setExpanded: PropTypes.func.isRequired,
    className: PropTypes.string,
    animate: PropTypes.bool,
    children: PropTypes.node.isRequired,
};

export default SideMenu;
